import { DesignAction, IContainerControlAttributes } from "../../../base/models";

import { ComponentsDialog } from "../../../base/register";
import { ControlType } from "../../../base/types";
import { DesignerMode } from "../../types";
import { DndItem } from "../../dnd/models";
import { Droppable } from "../../dnd";
import { PageControlDesigner } from "../PageControlDesigner";
import React from "react";
import { ViewPageControl } from "../ViewPageControl";
import { createControl } from "../../helpers";
import { useDesignContext } from "../../../providers";
import { useState } from "react"

export const ControlCollection = ({
    control, controls, orientation, additionalProps, onDesignChange
}: IContainerControlAttributes) => {
    const { control: { designerMode } } = useDesignContext()

    switch (designerMode) {
        case DesignerMode.Draft:
            return <DesignControlCollection
                control={control}
                controls={controls}
                orientation={orientation}
                additionalProps={additionalProps}
                onDesignChange={onDesignChange} />
        case DesignerMode.View:
            return <ViewControlCollection
                control={control}
                controls={controls}
                orientation={orientation}
                onDesignChange={() => { }}
                additionalProps={additionalProps} />
    }
}

const ViewControlCollection = ({
    controls, orientation, additionalProps
}: IContainerControlAttributes) => {
    if (!controls) return <></>

    return <>
        {controls.slice()
            .sort((a, b) => a.sequence - b.sequence)
            .map((ctrl) =>
                <React.Fragment key={ctrl.controlId}>
                    <ViewPageControl
                        control={ctrl}
                        orientation={orientation}
                        additionalProps={additionalProps}
                        onDesignChange={() => { }} />
                </React.Fragment>)}
    </>
}

const DesignControlCollection = ({
    control, controls, orientation: layout, additionalProps, onDesignChange
}: IContainerControlAttributes) => {
    const [dialog, showDialog] = useState<boolean>(false);
    const [targetControlId, setTargetControlId] = useState<string>()

    const onSelectComponent = (type: ControlType) => {
        if (!targetControlId) {
            console.error(`Could't insert the new control, target control is not updated.`)
            return;
        }

        setTimeout(() => {
            const newControl = createControl(type)
            onDesignChange({
                type: DesignAction.InsertAfterControl,
                controlId: targetControlId,
                control: newControl
            });
        }, 50)
    }

    const onDropItem = (item: DndItem, controlId: string) => {
        if (item.type !== "Control") return;

        onDesignChange({
            type: DesignAction.DropAfterControl,
            controlId,
            control: item.control
        });
    }

    const onInsertAfter = (controlId: string) => {
        setTargetControlId(controlId)
        showDialog(true);
    }

    return <>
        {controls.slice()
            .sort((a, b) => a.sequence - b.sequence)
            .map((ctrl) =>
                <React.Fragment key={ctrl.controlId}>
                    <PageControlDesigner
                        control={ctrl}
                        orientation={layout}
                        additionalProps={additionalProps}
                        onDesignChange={onDesignChange} >
                        <Droppable layout={layout}
                            title={`Click to insert a new component`}
                            onDropItem={(item) => onDropItem(item, ctrl.controlId)}
                            onClick={(e) => {
                                e.stopPropagation();
                                onInsertAfter(ctrl.controlId)
                            }} />
                    </PageControlDesigner>
                </React.Fragment>)}

        <ComponentsDialog
            show={dialog}
            onSelect={onSelectComponent}
            onHideModal={() => showDialog(false)}
        />
    </>
}